export default (function (totalPages, currentPage) {
    'use strict';
    var ret = '';
    for (var i = 1; i <= totalPages; i++) {
        ret += `<li><a href="javascript:void(0)" data-pagination-target="${i}" class="js-action--paginationLink${i === currentPage ? ' isCurrent' : ''}">${i}</a></li>`;
    }
    return ret;
});